import React, { createContext, useContext, ReactNode } from 'react';
import useColorHistory from '../hooks/useColorHistory';

type ColorHistoryContextType = {
	colorHistory: string[];
	addColorToHistory: (color: string) => void;
	selectColorFromHistory: (color: string) => string;
	clearHistory: () => void;
};

const ColorHistoryContext = createContext<ColorHistoryContextType | undefined>(undefined);

export const ColorHistoryProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const colorHistoryHook = useColorHistory();

	return <ColorHistoryContext.Provider value={colorHistoryHook}>{children}</ColorHistoryContext.Provider>;
};

export const useColorHistoryContext = (): ColorHistoryContextType => {
	const context = useContext(ColorHistoryContext);
	if (!context) {
		throw new Error('useColorHistoryContext must be used within a ColorHistoryProvider');
	}
	return context;
};
